import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { getaccountsaction } from "../../actions/getRolesActions"
import { getuserme } from "../../actions/userActions";
import ShowRoleTendantList from './ShowRoleTendatList'
import EditUserMe from './EditUserMe';
import NewPasswordUserMe from './NewPasswordUserMe';

import Grid from '@mui/material/Grid';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import Button from '@mui/material/Button';




 
class AccountInfo extends Component {

  constructor(props) {
    super(props);

    this.state = {
       edituserdata: false,
       editpassword: false,
    }

 this.handleCloseEditUserMe=this.handleCloseEditUserMe.bind(this);
 this.handleCloseSetPasswordUserMe=this.handleCloseSetPasswordUserMe.bind(this);
}

    componentDidMount() {
        this.props.getaccountsaction(this.props.apitoken);

        
      }

    handleCloseEditUserMe = () => {
      this.props.getaccountsaction(this.props.apitoken); 
        this.setState ({
          edituserdata: false
        })
        this.props.getuserme(this.props.apitoken);
      }

    handleCloseSetPasswordUserMe = () => {
      this.setState ({
        editpassword: false
      })
    }

    handleOpenEditUserMe = () => { 
        this.setState ({
          edituserdata: true
        })
      }

    
    handleOpenSetPasswordUserMe = () => { 
        this.setState ({
          editpassword: true
        })
      }

    render () {  
       console.log(this.state)
        
        const tendants = this.props.tendants
        const userme  = this.props.userme
        const changepassword  = this.props.localuser
        
        
        console.log (changepassword)
        
        //console.log(userme)
       // console.log(tendants)

        if (this.state.edituserdata) {
          return (
            <Fragment>
              <EditUserMe token={this.props.apitoken} edituserdata={userme} closedit={this.handleCloseEditUserMe} />
            </Fragment>
          )
         }
  
         if (this.state.editpassword) {
          return (
            <Fragment>
              <NewPasswordUserMe token={this.props.apitoken} edituserdata={userme} closedit={this.handleCloseSetPasswordUserMe} />
            </Fragment>
          )
         }
        
        return (
          <Fragment>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <h3>{intl.get('ACCOUNT_INFO_HEAD')}:</h3>
                <hr />
                <PersonIcon /><strong>{userme.firstName} {userme.lastName}</strong><br />
                <EmailIcon /> <strong>{userme.email}</strong>
                <hr />
                <InfoIcon /> <strong>{intl.get('ACCOUNT_INFO_INFO')}:</strong><br />
                {userme.description}
                <hr />
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                      <Button
                          onClick={() => {
                            this.handleOpenEditUserMe()
                          }}
                            fullWidth={true}
                            variant="outlined"
                            sx={{ mt: 1, mb: 1 }}
                            startIcon={<EditIcon />}
                          >
                              {intl.get('ACCOUNT_INFO_DATENBEARBEITEN')}
                          </Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {userme.isActive === true && changepassword === true &&
                      <Button
                          onClick={() => {
                            this.handleOpenSetPasswordUserMe()
                          }}
                            fullWidth={true}
                            variant="outlined"
                            sx={{ mt: 1, mb: 1 }}
                            startIcon={<LockIcon />}
                          >
                              {intl.get('ACCOUNT_INFO_PWBEARBEITEN')}
                          </Button>
                        }
                    </Grid>
                </Grid>  
            </Grid>
        <Grid item xs={12} sm={6}>
        <h3>{intl.get('ACCOUNT_INFO_ROLES')}:</h3>
        <hr />
        <ShowRoleTendantList userid={userme.id} auth={userme.authorizations} tendants={tendants} />
        </Grid>
        
      </Grid>
          </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken,
    userme: state.getuserdata.userme,
    tendants: state.getroles.accounts,
    localuser: state.getuserdata.userrights.isLocalUser
  });

  const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getaccountsaction: getaccountsaction,
        getuserme: getuserme
        }, dispatch);
    }





export default connect(mapStateToProps,mapDispatchToProps)(AccountInfo);
